export default {"src":"/_next/static/media/img-payment_survey_fail.97e897b1.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};